/* todo: remove helpers after migrate to catalog 2.0 */

// version: 1 - это категория /c_*
// version: 2 - это категория /catalog/*
export function isCheckCategoryVersion(path: string, version: 1 | 2): boolean {
  if (!path || !version) return false;

  if (version === 1) {
    return Boolean(path?.startsWith("/c_"));
  }

  if (version === 2) {
    return Boolean(path?.startsWith("/catalog/"));
  }

  return false;
}

// проверка категории на родителя лекарств
export function isBadCategory(category: Entity.Category): boolean {
  if (!category?.path) return false;

  return category.path.startsWith("2.");
}

// проверка категории на родителя лекарств
export function isDrugCategory(category: Entity.Category): boolean {
  if (!category?.path) return false;

  return category.path.startsWith("1.");
}

// TODO можно убрать после: перехода каталога на v2 и перемещение фильтров в query.params
export const recoveryCatForCatalogV2 = (
  objValue: Entity.Filters
): Entity.Filters => {
  if (!objValue) return objValue;
  if (!Array.isArray(objValue.lists)) return objValue;

  const lists = objValue.lists.map(item => {
    if (item.id === "cat") {
      return {
        id: item.id,
        vals: [`catalog/${item.vals}`],
      };
    }

    return item;
  });

  return {
    ...objValue,
    lists,
  };
};
